import data from "../../../../../packages/react/src/drafts/MarkdownToolbar/MarkdownToolbar.docs.json";
import * as React from 'react';
export default {
  data,
  React
};